/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataRequestModel } from '../../models/data-request-model';
import { MemberReportModel } from '../../models/member-report-model';

export interface IntegrationMemberReportSystemIdentifierIdPersonIdPost$Params {

/**
 * The unique identifier of the system
 */
  systemIdentifierId: string;

/**
 * The unique identifier of the person
 */
  personId: string;
  
    /**
     * The data request model containing date range
     */
    body?: DataRequestModel
}

export function integrationMemberReportSystemIdentifierIdPersonIdPost(http: HttpClient, rootUrl: string, params: IntegrationMemberReportSystemIdentifierIdPersonIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<MemberReportModel>> {
  const rb = new RequestBuilder(rootUrl, integrationMemberReportSystemIdentifierIdPersonIdPost.PATH, 'post');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<MemberReportModel>;
    })
  );
}

integrationMemberReportSystemIdentifierIdPersonIdPost.PATH = '/Integration/MemberReport/{systemIdentifierId}/{personId}';
